<template>
  <el-upload class="upload-demo"
             :headers="headers"
             :action="actionUrl"
             accept=".jpg,.png,.xlsx,.xls,.zip,.rar,.txt,.pdf"
             :on-preview="handlePreview"
             :on-remove="handleRemove"
             :before-remove="beforeRemove"
             multiple
             :file-list="fileList"
             :on-success="uploadSuccess"
             :limit="1"
             :on-exceed="handleExceed"
             :beforeUpload="beforeAvatarUpload">
    <el-button size="small"
               type="primary"
               @click="resumeSubmitFile">{{'上传文件'}}</el-button>
  </el-upload>
</template>
<script>
import Vue from 'vue'
export default {
  props: {
    fileList: {
      type: Array,
      default: function () {
        return []
      }
    },
    uploadSuccess: {
      type: Function,
      default: () => this.defaultUploadSuccess
    },
    beforeRemove: {
      type: Function,
      default: () => this.defaultBeforeRemove
    },
    resumeSubmitFile: {
      type: Function,
      default: () => this.defaultResumeSubmitFile
    }
  },
  data () {
    return {
      // 上传地址
      actionUrl: window.SITE_CONFIG['apiBaseURL'] + '/sys/config/appImgUpload'
    }
  },
  watch: {
  },
  components: {
  },
  computed: {
    // 获取请求头
    headers: function headers () {
      let headersObj = {
        token: Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
      }
      return headersObj
    }
  },
  methods: {
    handleRemove (file, fileList) {
      console.log(file)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning('上传文件数量超过限制')
    },
    defaultBeforeRemove (file, fileList) {
      console.log(file)
    },
    defaultResumeSubmitFile: function defaultResumeSubmitFile (item) {
      console.log(item)
    },
    // resumeSubmitFile(Authen){
    //   console.log('ddddd')
    //   console.log(Authen)
    // },
    // //文件上传的校验
    beforeAvatarUpload (file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      let uploadFormat = ['jpg', 'png', 'xlsx', 'xls', 'zip', 'rar', 'txt', 'pdf', 'JPG', 'PNG', 'XLSX', 'XLS', 'ZIP', 'RAR', 'TXT', 'PDF']
      let falg = uploadFormat.indexOf(testmsg)
      if (falg === -1) {
        this.$message.warning('只能上传jpg/png/xlsx/xls/zip/rar/txt/pdf文件')
        return false
      }
      // 上传文件限制4M
      let isLt2M = file.size / 1024 / 1024 <= 4
      if (!isLt2M) {
        this.$message.warning('上传文件大小不能超过 4MB!')
        return false
      }
    },
    // 上传成功拿到返回的信息
    defaultUploadSuccess: function defaultUploadSuccess (response, file, fileList, index) {
      console.log(response)
    }
  }
}
</script>
